import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/Services/utils.service';

@Component({
  selector: 'app-communicationv2',
  templateUrl: './communicationv2.component.html',
  styleUrls: ['./communicationv2.component.scss']
})
export class Communicationv2Component implements OnInit {
  browserDomain: string = window.location.hostname;

  constructor(private router: Router, private util: UtilsService) { }

  ngOnInit() {
    if(!this.browserDomain.includes('extramarks')){
      let hostName = window.location.hostname;
      let domainParts = hostName.split('.');
      let extractedDomain = domainParts.length > 2 ? domainParts.slice(1).join('.') : hostName;
      if(!(extractedDomain === 'oderp.in' || extractedDomain === 'odpay.in'))
      {
          window.open(this.util.loginUrl, "_blank");
          return;
      }
      let path = environment.reactConfig.communication.path || '';
      let redirectUrl = environment.reactConfig.communication.host + extractedDomain + path;
      
      const entity = localStorage.getItem('entityId') || '';
      const session = localStorage.getItem('session') || '';
      redirectUrl += `${path.includes('?') ? '&' : '?'}entity=${entity}&session=${session}`;
      
      const lastTime = sessionStorage.getItem('communicationRedirectTime');
      const now = Date.now();
      const isCooldown = lastTime && (now - parseInt(lastTime)) < 2000;
      
      if(!sessionStorage.getItem('communicationRedirect') || !isCooldown) {
        sessionStorage.setItem('communicationRedirect', 'true');
        sessionStorage.setItem('communicationRedirectTime', now.toString());
        window.open(redirectUrl, "_blank");
        setTimeout(() => {
          sessionStorage.removeItem('communicationRedirect');
          sessionStorage.removeItem('communicationRedirectTime');
        }, 2000);
      }
      
      setTimeout(() => {
        this.router.navigate(['/entity/dashboard']);
      }, 50);
    }
  }
}
